export default function TasksSolved() {
  const tasks = [
    { icon: 'ri-line-chart-line', title: 'Рост конверсии звонков', desc: 'Превращаем больше звонков в назначенные встречи и следующие шаги' },
    { icon: 'ri-shield-check-line', title: 'Холодные звонки без страха', desc: 'Убираем внутренний барьер и страх отказа через практическую отработку' },
    { icon: 'ri-calendar-check-line', title: 'Назначение встреч', desc: 'Учим уверенно договариваться о встрече как о естественном итоге разговора' },
    { icon: 'ri-key-2-line', title: 'Выход на ЛПР', desc: 'Техники прохождения секретаря и выхода на лицо, принимающее решение' },
    { icon: 'ri-search-eye-line', title: 'Выявление потребностей', desc: 'SPIN-вопросы и активное слушание для понимания истинных задач клиента' },
    { icon: 'ri-shield-user-line', title: 'Работа с секретарями', desc: 'Как превратить секретаря в союзника, а не в препятствие' },
    { icon: 'ri-chat-check-line', title: 'Работа с возражениями', desc: 'От защиты к управлению: превращаем возражения в продолжение диалога' },
    { icon: 'ri-money-dollar-circle-line', title: 'Продажа без скидок', desc: 'Переключаем разговор с цены на ценность — скидка становится ненужной' },
    { icon: 'ri-star-line', title: 'Продажа ценности', desc: 'Формулируем ценность так, чтобы клиент сам хотел продолжить диалог' },
    { icon: 'ri-loop-left-line', title: 'Повторные продажи', desc: 'Выстраиваем систему возврата к клиенту после первого контакта' },
    { icon: 'ri-database-2-line', title: 'Продажи существующей базе', desc: 'Учим работать с тёплой базой и увеличивать повторные продажи' },
    { icon: 'ri-arrow-up-circle-line', title: 'Увеличение среднего чека', desc: 'Техники допродаж и расширения сделки через правильные вопросы' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Какие задачи решает тренинг
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Программа закрывает полный цикл телефонных продаж — от первого касания до повторной сделки.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {tasks.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 hover:shadow-md transition-shadow group">
              <div className="w-10 h-10 bg-teal-50 rounded-lg flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-100 transition-colors">
                <i className={`${item.icon} text-teal-600 text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}